import { clsx } from 'clsx';
import * as React from 'react';
import { SingleSelectItem, ensureChildrenVisibility } from '../../../internal';
import styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export function GroupedSelectDesktopOptions(props) {
  const {
    open,
    indented,
    groupIndex,
    value,
    options,
    focusedIndex,
    actions
  } = props;
  const optionsContainerRef = React.useRef(null);
  const focusedOptionRef = React.useRef(null);
  React.useEffect(() => {
    const optionsContainer = optionsContainerRef.current;
    const focusedOption = focusedOptionRef.current;
    if (open && optionsContainer && focusedOption) {
      ensureChildrenVisibility(optionsContainer, focusedOption);
      focusedOption.focus();
    }
  }, [open, focusedIndex]);
  const bindHandleOptionClickIndex = index => () => {
    actions.selectOption({
      group: groupIndex,
      option: index
    });
    actions.closeDropdown();
  };
  const bindHandleOptionMouseMoveIndex = index => () => {
    if (focusedIndex.group !== groupIndex || focusedIndex.option !== index) {
      actions.setFocusedIndex({
        group: groupIndex,
        option: index
      });
    }
  };
  return /*#__PURE__*/_jsx("div", {
    ref: optionsContainerRef,
    className: styles['list'],
    children: options.map((option, index) => {
      const optionValue = option.value;
      const key = String(optionValue);
      const focused = groupIndex === focusedIndex.group && index === focusedIndex.option;
      const selected = value === optionValue;
      return /*#__PURE__*/_jsx("div", {
        ref: focused ? focusedOptionRef : undefined,
        className: clsx(styles['item-wrapper'], focused && styles['focused']),
        onClick: bindHandleOptionClickIndex(index),
        onMouseMove: bindHandleOptionMouseMoveIndex(index),
        role: "option",
        "aria-selected": selected ? 'true' : undefined,
        tabIndex: 0,
        children: /*#__PURE__*/_jsx("div", {
          className: clsx(styles['item'], indented && styles['indented']),
          children: /*#__PURE__*/_jsx(SingleSelectItem, {
            option: option,
            selected: selected
          })
        })
      }, key);
    })
  });
}